// Booking form validation utilities

import { FORM_VALIDATION } from '../constants/bookingConstants';

const normalizeText = (value) => String(value || '').trim();

export const validatePersonalDetails = (formData) => {
  const errors = {};
  const firstName = normalizeText(formData?.firstName);
  const lastName = normalizeText(formData?.lastName);
  const email = normalizeText(formData?.email);
  const phone = normalizeText(formData?.phone);
  
  if (!firstName) {
    errors.firstName = 'First name is required';
  }
  
  if (!lastName) {
    errors.lastName = 'Last name is required';
  }
  
  if (!email) {
    errors.email = 'Email is required';
  } else if (!FORM_VALIDATION.email.test(email)) {
    errors.email = 'Invalid email format';
  }
  
  if (!phone) {
    errors.phone = 'Phone number is required';
  } else if (!FORM_VALIDATION.phone.test(phone.replace(/\D/g, ''))) {
    errors.phone = 'Phone number must be 10 digits';
  }
  
  return errors;
};

export const validateEventDetails = (formData) => {
  const errors = {};
  const venue = normalizeText(formData?.venue);
  const address = normalizeText(formData?.address);
  const city = normalizeText(formData?.city);
  const state = normalizeText(formData?.state);
  const pincode = normalizeText(formData?.pincode);
  
  if (!formData.eventDate) {
    errors.eventDate = 'Event date is required';
  }
  
  if (!formData.eventTime) {
    errors.eventTime = 'Event time is required';
  }
  
  if (!venue) {
    errors.venue = 'Venue name is required';
  }
  
  if (!address) {
    errors.address = 'Address is required';
  }
  
  if (!city) {
    errors.city = 'City is required';
  }
  
  if (!state) {
    errors.state = 'State is required';
  }
  
  if (!pincode) {
    errors.pincode = 'Pincode is required';
  }
  
  return errors;
};

export const validateSingleStepBooking = (formData) => {
  return {
    ...validatePersonalDetails(formData),
    ...validateEventDetails(formData)
  };
};

export const validatePaymentDetails = (formData) => {
  const errors = {};
  
  if (!formData.termsAccepted) {
    errors.termsAccepted = 'Please accept terms and conditions';
  }
  
  return errors;
};

export const validateScheduleConfirmation = (formData) => {
  const errors = {};

  if (!formData.scheduleConfirmed) {
    errors.scheduleConfirmed = 'Please confirm your schedule details before continuing';
  }

  return errors;
};

export const BOOKING_STEP_VALIDATORS = {
  personal: validatePersonalDetails,
  event: validateEventDetails,
  schedule: validateScheduleConfirmation,
  payment: validatePaymentDetails,
  single: validateSingleStepBooking
};

const getValidatorKey = (step, flowSteps = []) => {
  if (typeof step === 'string') {
    return step;
  }

  const matchedStep = flowSteps.find((item) => Number(item.number) === Number(step));
  if (matchedStep?.validator) {
    return matchedStep.validator;
  }

  if (Number(step) === 1) return 'personal';
  if (Number(step) === 2) return 'event';
  if (Number(step) === 3) return 'schedule';
  if (Number(step) === 4) return 'payment';
  return null;
};

export const validateStep = (step, formData, flowSteps = []) => {
  const validatorKey = getValidatorKey(step, flowSteps);
  const validator = BOOKING_STEP_VALIDATORS[validatorKey];

  if (!validator) {
    return {};
  }

  return validator(formData);
};
